import React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Query } from 'react-apollo';
import SignIn from '../../components/login-flow-components/SignIn/SignIn';
import SuccessResult from '../../components/login-flow-components/SuccessResult/SuccessResult';
import ErrorResult from '../../components/login-flow-components/ErrorResult/ErrorResult';
import Poster from '../../components/Poster/Poster';
import RoomGQL from '../../graphql-operations/rooms.graphql';
import ErrorHandlingService from '../../services/error-handling.service';
import RoomService from '../../services/room.service';
import Spinner from '../../components/Spinner/Spinner';
import VisitForm from '../../components/login-flow-components/VisitForm/VisitForm';

/** This is what will store the user's inputs/selections through the login flow and then be submitted to create
 * a new Engage meeting. It is passed to the child components. TODO, after Redux integration: Use Redux actions
 * to update this. */
const newMeeting = { advisorRequested: 'First Available', student: {}, advisor: {} };

/** history comes from a route's render method, allows for routing when these methods are passed to the rendered,
 * stateless components */
const makeLoginFlowNavigations = room => ({
    goToSignin: history => history.push(`/${room.friendlyName}/signin`),
    goToCheckin: history => history.push(`/${room.friendlyName}/checkin/${room.id}`),
    goToSuccess: history => history.push(`/${room.friendlyName}/checkin/success/${room.id}`),
    goToError: history => history.push(`/${room.friendlyName}/checkin/error/${room.id}`),
});

const initializeData = (roomData) => {
    const room = RoomService.parseRoomConfigValues(roomData);
    Object.assign(newMeeting, { roomId: room.id });
    return room;
};

const LoginFlow = ({ match }) => {
    return (
        <Query query={RoomGQL.ROOM_QUERY} variables={{ roomName: match.params.roomName }}>
        {({ loading, error, data }) => {
            if (error) ErrorHandlingService.handleException(error);
            const room = initializeData(data.room);
            const { goToSignin, goToCheckin, goToError, goToSuccess } = makeLoginFlowNavigations(room);
            return loading ? <Spinner /> : (
                <Router>
                <div className="grid-y medium-grid-frame">
                    <div className="grid-x medium-grid-frame">
                        <section className="cell small-12 medium-6">
                            <Poster
                                room={room}
                                isRoomLoading={loading} />
                        </section>
                        <section className="cell small-12 medium-6">
                            <Route
                                exact
                                path="/:roomName/signin"
                                render={({ history }) =>
                                    <SignIn
                                        room={room}
                                        handleNav={() => goToCheckin(history)}
                                        meeting={newMeeting} />} />
                            <Route
                                exact
                                path="/:roomName/checkin/:roomId"
                                render={({ history }) =>
                                    <VisitForm
                                        room={room}
                                        meeting={newMeeting}
                                        handleErrorNav={() => goToError(history)}
                                        handleSuccessNav={() => goToSuccess(history)} />} />
                            <Route
                                exact
                                path="/:roomName/checkin/success/:roomId"
                                render={({ history }) =>
                                    <SuccessResult
                                        room={room}
                                        student={newMeeting.student}
                                        handleNav={() => goToSignin(history)} />} />
                            <Route
                                exact
                                path="/:roomName/checkin/error/:roomId"
                                render={({ history }) =>
                                    <ErrorResult
                                        room={room}
                                        handleNav={() => goToCheckin(history)}
                                        handleAutoNav={() => goToSignin(history)} />} />
                        </section>
                    </div>
                </div>
                </Router>);
        }}
        </Query>
    );
};

export default LoginFlow;

LoginFlow.propTypes = {
    match: PropTypes.object,
};

LoginFlow.defaultProps = {
    match: {},
};



// WEBPACK FOOTER //
// ./src/containers/LoginFlow/LoginFlow.jsx